import { Component, Input } from '@angular/core';
import { DateTimeFormatPipe } from '../../../orders/components/order-details/pipes/date-time-format.pipe';
import { Order } from '../../../overview/models/order';
import { OrderExceptionTableSkeletonComponent } from '../order-exception-table-skeleton/order-exception-table-skeleton.component';
import { OrderException } from '../../../overview/models/order-exception';
import { OrderExceptionLogsTableComponent } from '../order-exception-logs-table/order-exception-logs-table.component';
import { MatDivider } from '@angular/material/divider';
import { last } from 'rxjs';

@Component({
  selector: 'app-order-exception-table',
  standalone: true,
  templateUrl: './order-exception-table.component.html',
  imports: [DateTimeFormatPipe, OrderExceptionTableSkeletonComponent, OrderExceptionLogsTableComponent, MatDivider],
  styleUrl: './order-exception-table.component.scss'
})
export class OrderExceptionTableComponent {
  @Input() orderExceptions: OrderException[] | null = null;
  protected readonly last = last;
}
